export enum AnswerQuestionThemeTypes {
  slides = 'slides',
}
